<template>
  <div class="toast" :class="`toast--${type}`">
    <div class="toast__icon">
      <svg v-if="type === 'error'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-40.4-320.6c7.5-7.5 19.8-7.5 27.3 0l40 40c7.5 7.5 7.5 19.8 0 27.3l-40 40c-7.5 7.5-19.8 7.5-27.3 0l-40-40c-7.5-7.5-7.5-19.8 0-27.3l40-40zm-1.1 120.2c7.5-7.5 19.8-7.5 27.3 0l40 40c7.5 7.5 7.5 19.8 0 27.3l-40 40c-7.5 7.5-19.8 7.5-27.3 0l-40-40c-7.5-7.5-7.5-19.8 0-27.3l40-40z"/>
      </svg>
      <svg v-else-if="type === 'success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"/>
      </svg>
    </div>
    <p class="toast__message">{{ message }}</p>
    <button @click="$emit('remove')" class="toast__close-btn" aria-label="Close">&times;</button>
  </div>
</template>

<script setup>
defineProps({
  message: { type: String, required: true },
  type: { type: String, default: 'info' } // info, success, error
});
defineEmits(['remove']);
</script>

<style scoped>
/* Style untuk setiap notifikasi */
.toast {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.15);
  border: 1px solid;
  width: 100%;
  max-width: 350px;
  font-family: 'Epilogue', sans-serif;
}

.toast--info {
  background-color: #eaf5fd;
  border-color: #6DD5FA;
  color: #2980B9;
}
.toast--success {
  background-color: #e9f9f0;
  border-color: #27ae60;
  color: #1e8449;
}
.toast--error {
  background-color: #fdeaea;
  border-color: #FF6B6B;
  color: #c0392b;
}

.toast__icon {
  margin-right: 1rem;
  flex-shrink: 0; /* Mencegah ikon menyusut */
}
.toast__icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.toast__message {
  flex-grow: 1;
  font-weight: 500;
  line-height: 1.4;
}

.toast__close-btn {
  background: none;
  border: none;
  font-size: 1.75rem;
  font-weight: 300;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  padding: 0 0.5rem;
}
.toast__close-btn:hover {
  opacity: 1;
}
</style>